import * as React from 'react';

export enum NotificationIntent {
  SUCCESS = 'success',
  ERROR = 'error',
  INFO = 'info',
  WARNING = 'warning'
}

export interface NotificationProps {
  uid: string | number;
  title: string;
  body: React.ReactNode;
  intent?: NotificationIntent;
  showCloseButton?: boolean;
  autoClose?: boolean;
  duration?: number;
  onClose?: (notification: NotificationProps) => void;
}

export interface NotificationsProps {
  notifications: NotificationProps[];
  onClose: (notification: NotificationProps) => void;
}



// WEBPACK FOOTER //
// ./src/components/Notifications/types.ts